import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { Equals, IsNotEmpty, IsNumber, IsOptional, IsString, Min } from 'class-validator';
import { PromotionExposeGroup, PromotionMustBuyConditionTypeEnum } from '../interface';
import { CreateAbstractPromotionMustBuyConditionDto } from './CreateAbstractPromotionMustBuyConditionDto';
export class CreatePromotionItemMustBuyConditionDto extends CreateAbstractPromotionMustBuyConditionDto {
    constructor() {
        super(...arguments);
        this.type = PromotionMustBuyConditionTypeEnum.ITEM;
        this.quantity = 1;
    }
}
__decorate([
    ApiProperty({
        enum: [PromotionMustBuyConditionTypeEnum.ITEM],
        description: 'Items that must be present in the cart',
        example: PromotionMustBuyConditionTypeEnum.ITEM,
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Equals(PromotionMustBuyConditionTypeEnum.ITEM, { always: true }),
    __metadata("design:type", String)
], CreatePromotionItemMustBuyConditionDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Uuid of the location', example: 'f2f94d64-3928-4eb4-b3fd-15cc23c6d096' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], CreatePromotionItemMustBuyConditionDto.prototype, "storeId", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Uuid of the must buy item/category', example: 'f2f94d64-3928-4eb4-b3fd-15cc23c6d096' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], CreatePromotionItemMustBuyConditionDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'Required quantity', example: 42, default: 1 }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Min(1, { always: true }),
    IsNumber(undefined, { always: true }),
    __metadata("design:type", Number)
], CreatePromotionItemMustBuyConditionDto.prototype, "quantity", void 0);
//# sourceMappingURL=CreatePromotionItemMustBuyConditionDto.js.map